import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Root as Portal } from '@radix-ui/react-portal';
import { isNumber } from '@showroomjs/core';
import * as React from 'react';
import { NotificationProvider as StateProvider, useNotificationState, } from '../lib/use-notification';
import { styled } from '../stitches.config';
export const NotificationProvider = (props) => {
    const { items, append } = useNotificationState([]);
    const appendNotification = React.useCallback((msg, { removeAfterMs = 1000 } = {}) => append({
        msg,
        autoDismiss: isNumber(removeAfterMs),
    }, { removeAfterMs }), [append]);
    return (_jsxs(StateProvider, { value: appendNotification, children: [props.children, items.length > 0 && (_jsx(Portal, { children: _jsx(MessageRoot, { children: _jsx(MessageList, { children: items.map((it) => (_jsx(MessageItem, { children: it.value.msg }, it.key))) }) }) }))] }));
};
const MessageRoot = styled('div', {
    position: 'fixed',
    bottom: '$2',
    right: '50%',
    transform: 'translateX(50%)',
    '@sm': {
        top: '$2',
        right: '$2',
        bottom: 'auto',
        transform: 'translateX(0)',
    },
});
const MessageList = styled('ul', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$3',
});
const MessageItem = styled('li', {
    color: '$gray-100',
    backgroundColor: '$gray-800',
    px: '$4',
    py: '$2',
    borderRadius: '$lg',
    shadow: 'lg',
});
//# sourceMappingURL=notification-provider.js.map